module.exports = __webpack_public_path__ + "static/media/4.60a26bee.png";